import Axios from "axios";
export default class logged_in {

getLoggedIn(data) {

    return new Promise((resolve, reject) => {
      //let that = store;
      console.info('logged in',data);
      let hostname = window.location.hostname;
      console.info('logged in',hostname);
      let http = 'https://';
      if (hostname == 'localhost') {
          hostname = 'localhost/vistosiwoocommerce';
          http = 'http://';
      }
      let params = new URLSearchParams();
      params.append('action', 'loggedinvuejs');
      params.append('data', data);
      Axios.post(
        http + hostname + "/wp-admin/admin-ajax.php",
        params
      )
        .then(function (response) {
          console.info('logged in',response);
          resolve(response);
        })
        .catch(function (error) {
          console.info('logged in',error);
          reject(error);
        });
    });

  }

  uploadFile(file, codice_univoco){
    return new Promise((resolve, reject) => {
        //let that = store;
        let hostname = window.location.hostname;
        console.info('logged in',hostname);
        let http = 'https://';
        if (hostname == 'localhost') {
            hostname = 'localhost/vistosiwoocommerce';
            http = 'http://';
        }
        let params = new FormData();
        params.append('action', 'uploadfile');
        params.append('file', file);
        params.append('codice', codice_univoco);
        Axios.post(
          http + hostname + "/wp-admin/admin-ajax.php",
          params,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        )
          .then(function (response) {
            console.info('logged in',response);
            resolve(response);
          })
          .catch(function (error) {
            console.info('logged in',error);
            reject(error);
          });
      });
  }
  uploadFileP(file, codice_univoco){
    return new Promise((resolve, reject) => {
        //let that = store;
        let hostname = window.location.hostname;
        console.info('logged in',hostname);
        let http = 'https://';
        if (hostname == 'localhost') {
            hostname = 'localhost/vistosiwoocommerce';
            http = 'http://';
        }
        let params = new FormData();
        params.append('action', 'uploadfilep');
        params.append('file', file);
        params.append('codice', codice_univoco);
        Axios.post(
          http + hostname + "/wp-admin/admin-ajax.php",
          params,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        )
          .then(function (response) {
            console.info('logged in',response);
            resolve(response);
          })
          .catch(function (error) {
            console.info('logged in',error);
            reject(error);
          });
      });
  }
}